import { PRINCIPLES } from "@/lib/site";

export default function Principles() {
    return (
        <section
            id="principles"
            data-testid="principles-section"
            className="py-24 md:py-32 lg:py-40"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-12 gap-6 md:gap-12 mb-16 md:mb-20">
                    <div className="col-span-12 md:col-span-7">
                        <span className="number-mark text-ink2">§ 04</span>
                        <h2
                            data-testid="principles-heading"
                            className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] text-ink max-w-3xl"
                        >
                            Six principles that hold
                            this work together.
                        </h2>
                    </div>
                </div>

                <ol
                    data-testid="principles-list"
                    className="divide-y divide-rule border-t border-b border-rule"
                >
                    {PRINCIPLES.map((p, i) => (
                        <li
                            key={p.n}
                            data-testid={`principle-${i}`}
                            className="grid grid-cols-12 gap-4 md:gap-8 py-8 md:py-10 group hover:bg-bone2 transition-colors px-2 md:px-4"
                        >
                            <div className="col-span-2 md:col-span-1">
                                <span className="font-serif text-2xl md:text-3xl italic text-ochre">
                                    {p.n}
                                </span>
                            </div>
                            <div className="col-span-10 md:col-span-5">
                                <h3 className="font-serif text-2xl md:text-3xl lg:text-[34px] leading-[1.05] text-ink">
                                    {p.title}
                                </h3>
                            </div>
                            <div className="col-span-12 md:col-span-6 md:pl-6">
                                <p className="text-ink2 text-[16px] md:text-lg leading-relaxed max-w-xl">
                                    {p.body}
                                </p>
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
}
